/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import { FLOATING_LAYER_ID } from '@/components/ui/layer';

/**
 * The layer menus and filter lists open into, mounted once inside `<main>` by
 * the app frame. Empty until one opens; see `layer.ts` for why it is here and
 * not on the body.
 */
export function FloatingLayer() {
  return <div id={FLOATING_LAYER_ID} className="floating-layer" />;
}
